module.exports = __webpack_public_path__ + "img/fixed_lightning.0569212a.svg";